import AuthActions from '../../actions/AuthActions';
import NotificationActions from '../../actions/NotificationActions';
import Cookies from 'universal-cookie';
import AuthStore from '../../stores/AuthStore';
import ConfigStore from '../../stores/ConfigStore';
import PosStore from '../../stores/PosStore';
import UserApi from '../../api/UserApi';

class Auth extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            username: '',
            password: '',

            load: false,
            bypassed: false,
            visible: false,
            user: null,
            isSSOLoginEnabled: false,
            isSSO: this.props.isSSO ? this.props.isSSO : false,
            flags: null,
        };

        this.onAuthStoreChange = this.onAuthStoreChange.bind(this);
        this.forgot = this.forgot.bind(this);
        this.login = this.login.bind(this);
        this.ssologin = this.ssologin.bind(this);
        this.onPosStoreChange = this.onPosStoreChange.bind(this);
    }

    isSurface() {
        const isWindows = navigator.userAgent.indexOf('Windows') > -1;
        const maxTouchPoints = navigator.maxTouchPoints || navigator.msMaxTouchPoints;
        const isTouchable =
            'ontouchstart' in window ||
            maxTouchPoints > 0 ||
            (window.matchMedia && matchMedia('(any-pointer: coarse)').matches);

        return isWindows && isTouchable;
    }

    checkCookies() {
        var cookies = new Cookies();
        var c = cookies.get('LeafLogixSessionInfo', { path: '/' });
        if (!!c) {
            this.setState({ bypassed: true }, () => AuthActions.autoLogin(c));
        }
    }

    componentWillMount() {
        if (ConfigStore.useAutoLogin()) {
            this.checkCookies();
        }
    }

    async componentDidMount() {
        if (
            location.host.toLowerCase().includes('curaleaf-pos.leaflogix.net') ||
            location.host.toLowerCase().includes('curaleaf-uat-pos.leaflogix.net')
        ) {
            this.setState({ isSSO: true });
        }
        PosStore.addChangeListener(this.onPosStoreChange);
        AuthStore.addChangeListener(this.onAuthStoreChange);

        $(document).on('keypress', (e) => {
            if (e.keyCode == 13 && ($('#auth-username').is(':focus') || $('#auth-password').is(':focus'))) {
                if (this.state.isSSO) {
                    this.ssologin();
                } else {
                    this.login();
                }
            }
        });

        $('#auth-username').focus();

        let flags = {};

        try {
            const response = await UserApi.getLaunchDarklyFlags({
                LspId: null,
                LocId: null,
            });
            flags = response.Data;
        } catch (error) {
            console.error('Error fetching flags', error);
        } finally {
            this.setState({ flags });
        }
    }

    conponentWillUnmount() {
        this.setState({
            username: '',
            password: '',
            load: false,
        });

        PosStore.removeChangeListener(this.onPosStoreChange);
        AuthStore.removeChangeListener(this.onAuthStoreChange);
        $(document).off('keypress');
    }

    onPosStoreChange() {
        this.setState({
            isSSOLoginEnabled: PosStore.getState().isSSOLoginEnabled,
        });
    }

    onAuthStoreChange(data) {
        if (data.event === 'login' && data.error) {
            if (
                (!data.user.LoginFailureCount && !data.user.MaxLoginFailureCount) ||
                data.user.LoginFailureCount < data.user.MaxLoginFailureCount
            ) {
                this.setState({ load: false, bypassed: false }, () => {
                    setTimeout(() => {
                        NotificationActions.alert('Username and Password does not match');
                    }, 10);
                });
            } else {
                this.setState({ load: false, bypassed: false, visible: true, user: data.user });
            }
        } else if (data.event === 'ssologin' && data.error) {
            this.setState({ load: false, bypassed: false }, () => {
                setTimeout(() => {
                    NotificationActions.alert('SSO login failed');
                }, 10);
            });
        } else if (data.event === 'logout') {
            this.setState({ load: false, bypassed: false });
        } else {
            this.setState({
                username: '',
                password: '',
                load: false,
            });
        }
    }

    login() {
        if (this.state.loading) return;

        let error = false;
        let username = this.state.username;
        let password = this.state.password;
        let url = window.location.origin;

        if (username.length < 1) {
            this.setState({ userStatus: 'auth__error' }, () => NotificationActions.alert('Username is missing'));
            return;
        }

        if (password.length < 1) {
            this.setState({ passStatus: 'auth__error' }, () => NotificationActions.alert('Password is missing'));
            return;
        }

        if (!error) {
            this.setState({ load: true }, () => {
                AuthActions.login({
                    username: username,
                    password: password,
                    url: url,
                });
            });
        }
    }

    ssologin() {
        if (this.state.loading) return;

        let error = false;
        let username = this.state.username;

        if (username.length < 1) {
            this.setState({ userStatus: 'auth__error' }, () => NotificationActions.alert('Username is missing'));
            return;
        }

        if (!error) {
            this.setState({ load: true }, () => {
                AuthActions.ssologin({
                    username: username,
                });
            });
        }
    }

    forgot() {
        let error = false;
        let username = this.state.username;
        const url = window.location.origin;

        if (username.length < 1) {
            error = true;
            setTimeout(() => {
                NotificationActions.alert('Username with valid email address is required');
            }, 10);
            this.setState({ userStatus: 'auth__error' });
            return;
        }

        if (username.indexOf(' ') >= 0) {
            error = true;
            setTimeout(() => {
                NotificationActions.alert('White space characters are not allowed');
            }, 10);
            this.setState({ userStatus: 'auth__error' });
            return;
        }

        if (!error) {
            AuthActions.forgot({
                UserName: username,
                Url: url,
            });
            setTimeout(() => {
                NotificationActions.alert(
                    'If a user matching this username exists in our records, an email has been sent to them.'
                );
            }, 10);
        }
    }

    render() {
        if (this.props.user || this.state.bypassed) return null;

        if (!this.state.flags) {
            return (
                <div
                    style={{
                        height: '100%',
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <i className='fa fa-spinner fa-pulse' />
                </div>
            );
        }

        if (this.state.flags['pos.backoffice.new-login-page.rollout']) {
            return (
                <div id='auth-reskin' className='auth-reskin'>
                    <div className='LayoutBase'>
                        <div className='HeroContainer'>
                            <img className='HeroImage' src='/assets/dutchie-hero.svg' />
                        </div>
                        <div className='AsideForm'>
                            <div className='InfoMessage'>
                                <strong>Note: </strong> LeafLogix users can login with their existing credentials.
                            </div>
                            <input
                                type='text'
                                id='auth-reskin-username'
                                data-testid='auth-reskin_input_username'
                                value={this.state.username}
                                className={this.state.userStatus}
                                onChange={(e) => {
                                    this.setState({ username: e.target.value });
                                }}
                                onFocus={() => this.setState({ userStatus: '' })}
                                placeholder='Username'
                            />
                            {!this.state.isSSO && (
                                <input
                                    type='password'
                                    id='auth-reskin-password'
                                    data-testid='auth-reskin_input_password'
                                    value={this.state.password}
                                    className={this.state.passStatus}
                                    onChange={(e) => {
                                        this.setState({ password: e.target.value });
                                    }}
                                    onFocus={() => this.setState({ passStatus: '' })}
                                    placeholder='Password'
                                />
                            )}
                            <div className='ButtonContainer'>
                                <div>
                                    {!this.state.isSSO && (
                                        <button
                                            className='auth-reskin__go PrimaryButton'
                                            data-testid='auth-reskin_button_go-green'
                                            onClick={this.login}
                                        >
                                            {!this.state.load ? (
                                                'Sign in'
                                            ) : (
                                                <i className='fa fa-spinner fa-pulse' aria-hidden='true' />
                                            )}
                                        </button>
                                    )}
                                    {(this.state.isSSOLoginEnabled || this.state.isSSO) && (
                                        <button
                                            className='auth-reskin__go PrimaryButton'
                                            data-testid='auth-reskin_button_go-blue'
                                            onClick={this.ssologin}
                                        >
                                            {!this.state.load ? (
                                                'SSO'
                                            ) : (
                                                <i className='fa fa-spinner fa-pulse' aria-hidden='true' />
                                            )}
                                        </button>
                                    )}
                                </div>
                                {!this.state.isSSO && (
                                    <button
                                        className='auth-reskin__content--right LinkButton'
                                        data-testid='auth-reskin_button_forgot-password'
                                        onClick={this.forgot}
                                    >
                                        Forgot password?
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>

                    {this.state.visible && (
                        <div className='popup popup__transparent'>
                            <div className='popup__content release' style={{ height: 180, width: 400 }}>
                                <div className='popup-header'>
                                    ACCOUNT LOCKED
                                    <div
                                        className='popup-close'
                                        onClick={() => {
                                            this.setState({ visible: false });
                                        }}
                                    >
                                        <i className='fa fa-times' aria-hidden='true' />
                                    </div>
                                </div>

                                <div style={{ margin: '10px' }}>
                                    {`Your account has been blocked after ${
                                        this.state.user.MaxLoginFailureCount
                                    } login failures. Please wait ${
                                        this.state.user.MaxRetryMinutes - this.state.user.RetryMinutes
                                    } minutes and try again.`}
                                </div>

                                <div
                                    className='btn-green'
                                    onClick={() => {
                                        this.setState({ visible: false });
                                    }}
                                    style={{ width: '380px', margin: '10px 0 0 10px' }}
                                >
                                    OK
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            );
        }

        return (
            <div id='auth' className='auth'>
                <div className='auth__background' />

                <div className={!this.isSurface() ? 'auth__content' : 'auth__content__with__keyboard'}>
                    <div className='auth__content--logo'>
                        <img src='/assets/logo.png' />
                    </div>

                    <p>USERNAME</p>

                    <input
                        type='text'
                        id='auth-username'
                        data-testid='auth_input_username'
                        value={this.state.username}
                        className={this.state.userStatus}
                        onChange={(e) => {
                            this.setState({ username: e.target.value });
                        }}
                        onFocus={() => this.setState({ userStatus: '' })}
                        placeholder='Username'
                    />
                    {!this.state.isSSO && <p>PASSWORD</p>}
                    {!this.state.isSSO && (
                        <input
                            type='password'
                            id='auth-password'
                            data-testid='auth_input_password'
                            value={this.state.password}
                            className={this.state.passStatus}
                            onChange={(e) => {
                                this.setState({ password: e.target.value });
                            }}
                            onFocus={() => this.setState({ passStatus: '' })}
                            placeholder='Password'
                        />
                    )}
                    {!this.state.isSSO && (
                        <button
                            className='auth__go btn-primary btn-green'
                            data-testid='auth_button_go-green'
                            onClick={this.login}
                        >
                            {!this.state.load ? 'GO' : <i className='fa fa-spinner fa-pulse' aria-hidden='true' />}
                        </button>
                    )}
                    {(this.state.isSSOLoginEnabled || this.state.isSSO) && (
                        <button
                            className='auth__go btn-primary btn-blue'
                            data-testid='auth_button_go-blue'
                            onClick={this.ssologin}
                        >
                            {!this.state.load ? 'SSO' : <i className='fa fa-spinner fa-pulse' aria-hidden='true' />}
                        </button>
                    )}
                    {!this.state.isSSO && (
                        <button
                            className='auth__content--right'
                            data-testid='auth_button_forgot-password'
                            onClick={this.forgot}
                        >
                            Forgot Password?
                        </button>
                    )}
                </div>

                {this.state.visible && (
                    <div className='popup popup__transparent'>
                        <div className='popup__content release' style={{ height: 180, width: 400 }}>
                            <div className='popup-header'>
                                ACCOUNT LOCKED
                                <div
                                    className='popup-close'
                                    onClick={() => {
                                        this.setState({ visible: false });
                                    }}
                                >
                                    <i className='fa fa-times' aria-hidden='true' />
                                </div>
                            </div>

                            <div style={{ margin: '10px' }}>
                                {`Your account has been blocked after ${
                                    this.state.user.MaxLoginFailureCount
                                } login failures. Please wait ${
                                    this.state.user.MaxRetryMinutes - this.state.user.RetryMinutes
                                } minutes and try again.`}
                            </div>

                            <div
                                className='btn-green'
                                onClick={() => {
                                    this.setState({ visible: false });
                                }}
                                style={{ width: '380px', margin: '10px 0 0 10px' }}
                            >
                                OK
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default Auth;

/*


                <div className='auth__version'>
                    {ConfigStore.getVersion()}
                </div>


*/



// WEBPACK FOOTER //
// ./ui_src/app/components/auth/Auth.react.jsx